/* src/app/front-layout/calendar/elev-plus-tests/elev-plus-tests.component.css */
.mt-page {
  --mt-p: #0B4F6C;
  --mt-s: #01BAEF;
  --mt-g: #F5A623;
  --mt-d: #06253A;
  --mt-li: #EBF7FB;
  --mt-bo: #CBECF4;
  --mt-mu: #6B8FA0;
  --mt-bg: #F4F8FA;
  --mt-surf: #FFFFFF;
  --mt-tx: #1E3A4A;
  --mt-tl: #4A6477;
  --mt-f2f: #0B8A4E;
  --mt-onl: #7C3AED;
  --mt-err: #C0392B;
  font-family:
    "Nunito",
    "Segoe UI",
    sans-serif;
  color: var(--mt-tx);
  background: var(--mt-bg);
  box-sizing: border-box;
  overflow-x: hidden;
}
.mt-page * {
  box-sizing: border-box;
}
.mt-page h1,
.mt-page h2,
.mt-page h3,
.mt-page h4,
.mt-page p {
  margin: 0;
  padding: 0;
}
.mt-container {
  max-width: 1240px !important;
  width: 100% !important;
  margin-left: auto !important;
  margin-right: auto !important;
  padding-left: 48px !important;
  padding-right: 48px !important;
  float: none !important;
}
.mt-eyebrow {
  font-size: 11px !important;
  font-weight: 800 !important;
  letter-spacing: .14em;
  text-transform: uppercase;
  color: var(--mt-s) !important;
  display: flex !important;
  align-items: center;
  gap: 8px;
}
.mt-eyebrow::before,
.mt-eyebrow::after {
  content: "";
  height: 2px;
  width: 18px;
  background: var(--mt-s);
  border-radius: 2px;
  display: block;
  flex-shrink: 0;
}
.mt-eyebrow--light {
  color: rgba(255, 255, 255, .6) !important;
}
.mt-eyebrow--light::before,
.mt-eyebrow--light::after {
  background: rgba(255, 255, 255, .35);
}
.mt-section-title {
  font-size: clamp(23px, 3vw, 36px) !important;
  font-weight: 900 !important;
  color: var(--mt-d) !important;
  line-height: 1.2 !important;
  letter-spacing: -.4px;
}
.mt-section-title span {
  color: var(--mt-s) !important;
}
.mt-section-title--light {
  color: #fff !important;
}
.mt-section-title--light span {
  color: var(--mt-g) !important;
}
.mt-section-sub {
  font-size: 15px !important;
  color: var(--mt-tl) !important;
  line-height: 1.7 !important;
  margin-top: 10px !important;
  max-width: 540px;
}
.mt-section-hd {
  text-align: center !important;
  margin-bottom: 44px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 8px;
}
.mt-section-hd--light .mt-section-title {
  color: #fff !important;
}
.mt-btn-primary {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  background: var(--mt-g) !important;
  color: var(--mt-d) !important;
  border: none !important;
  border-radius: 100px !important;
  padding: 13px 28px !important;
  font-size: 15px !important;
  font-weight: 800 !important;
  cursor: pointer;
  font-family: inherit;
  transition: transform .2s, box-shadow .2s;
}
.mt-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(245, 166, 35, .35) !important;
}
.mt-btn-ghost {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, .1) !important;
  color: rgba(255, 255, 255, .9) !important;
  border: 1.5px solid rgba(255, 255, 255, .25) !important;
  border-radius: 100px !important;
  padding: 11px 24px !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  cursor: pointer;
  font-family: inherit;
  transition: background .2s;
}
.mt-btn-ghost:hover {
  background: rgba(255, 255, 255, .18) !important;
}
.mt-hero {
  background:
    linear-gradient(
      135deg,
      #04111a 0%,
      var(--mt-d) 55%,
      #0a6070 100%) !important;
  padding: 80px 0 64px !important;
  position: relative;
  overflow: hidden;
  width: 100% !important;
}
.mt-hero-blob {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}
.mt-hero-blob--1 {
  width: 600px;
  height: 600px;
  background:
    radial-gradient(
      circle,
      rgba(1, 186, 239, .07) 0%,
      transparent 70%);
  top: -200px;
  right: -150px;
}
.mt-hero-blob--2 {
  width: 300px;
  height: 300px;
  background:
    radial-gradient(
      circle,
      rgba(245, 166, 35, .06) 0%,
      transparent 70%);
  bottom: -100px;
  left: -60px;
}
.mt-hero-inner {
  display: grid !important;
  grid-template-columns: 1fr 420px !important;
  gap: 52px !important;
  align-items: center !important;
  position: relative;
  z-index: 1;
  width: 100% !important;
}
.mt-hero-badge {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  background: rgba(245, 166, 35, .15);
  border: 1px solid rgba(245, 166, 35, .3);
  border-radius: 100px;
  padding: 7px 16px;
  font-size: 12px !important;
  font-weight: 700 !important;
  color: var(--mt-g) !important;
  letter-spacing: .04em;
  margin-bottom: 18px;
}
.mt-badge-pulse {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--mt-g);
  animation: mt-pulse 2s infinite;
  flex-shrink: 0;
}
@keyframes mt-pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.5);
    opacity: .5;
  }
}
.mt-hero-title {
  font-size: clamp(30px, 4.5vw, 52px) !important;
  font-weight: 900 !important;
  color: #fff !important;
  line-height: 1.1 !important;
  letter-spacing: -1px;
  margin-bottom: 14px !important;
}
.mt-hero-title em {
  font-style: normal;
  color: var(--mt-s) !important;
}
.mt-hero-sub {
  font-size: 15px !important;
  color: rgba(255, 255, 255, .62) !important;
  line-height: 1.7 !important;
  margin-bottom: 24px !important;
}
.mt-hero-actions {
  display: flex !important;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 28px;
}
.mt-hero-stats {
  display: flex !important;
  align-items: center;
  gap: 0;
  flex-wrap: wrap;
  background: rgba(255, 255, 255, .06);
  border: 1px solid rgba(255, 255, 255, .1);
  border-radius: 14px;
  padding: 14px 20px !important;
}
.mt-hstat {
  text-align: center;
  padding: 0 18px !important;
}
.mt-hstat strong {
  display: block;
  font-size: 18px !important;
  font-weight: 900 !important;
  color: var(--mt-g) !important;
  line-height: 1;
  margin-bottom: 3px;
}
.mt-hstat span {
  font-size: 10px !important;
  color: rgba(255, 255, 255, .45) !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: .06em;
}
.mt-hstat-div {
  width: 1px;
  height: 32px;
  background: rgba(255, 255, 255, .1);
  flex-shrink: 0;
}
.mt-hero-guide {
  background: rgba(255, 255, 255, .06);
  border: 1.5px solid rgba(255, 255, 255, .12);
  border-radius: 20px;
  padding: 28px !important;
}
.mt-guide-title {
  display: flex !important;
  align-items: center;
  gap: 7px;
  font-size: 13px !important;
  font-weight: 800 !important;
  color: var(--mt-s) !important;
  letter-spacing: .06em;
  text-transform: uppercase;
  margin-bottom: 22px;
}
.mt-guide-steps {
  display: flex !important;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}
.mt-gstep {
  display: flex !important;
  align-items: flex-start;
  gap: 14px;
}
.mt-gstep-num {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background:
    linear-gradient(
      135deg,
      var(--mt-p),
      var(--mt-s));
  display: flex !important;
  align-items: center;
  justify-content: center;
  font-size: 13px !important;
  font-weight: 900 !important;
  color: #fff !important;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(11, 79, 108, .25);
}
.mt-gstep-label {
  font-size: 14px !important;
  font-weight: 800 !important;
  color: #fff !important;
  margin-bottom: 2px;
}
.mt-gstep-sub {
  font-size: 12px !important;
  color: rgba(255, 255, 255, .5) !important;
  font-weight: 600 !important;
}
.mt-guide-cta {
  width: 100% !important;
  background: var(--mt-g) !important;
  color: var(--mt-d) !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 13px 20px !important;
  font-size: 15px !important;
  font-weight: 800 !important;
  cursor: pointer;
  font-family: inherit;
  transition: transform .2s;
}
.mt-guide-cta:hover {
  transform: translateY(-2px);
}
.mt-offers {
  background:
    linear-gradient(
      90deg,
      #fff7e0,
      #ffe8b3) !important;
  border-bottom: 2px solid rgba(245, 166, 35, .3);
  width: 100% !important;
}
.mt-offers-inner {
  display: flex !important;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  padding-top: 13px !important;
  padding-bottom: 13px !important;
}
.mt-offers-pulse {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--mt-g);
  animation: mt-pulse 2s infinite;
  flex-shrink: 0;
}
.mt-offers-text {
  flex: 1;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: var(--mt-tx) !important;
}
.mt-offers-text strong {
  color: var(--mt-p) !important;
  font-size: 15px !important;
}
.mt-offers-btn {
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
  background: var(--mt-p) !important;
  color: #fff !important;
  border: none !important;
  border-radius: 100px !important;
  padding: 8px 20px !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  cursor: pointer;
  text-decoration: none !important;
  white-space: nowrap;
  transition: background .2s;
}
.mt-offers-btn:hover {
  background: var(--mt-s) !important;
}
.mt-types {
  padding: 72px 0 !important;
  background: var(--mt-surf) !important;
  width: 100% !important;
}
.mt-type-single {
  width: 100% !important;
}
.mt-type-card-wide {
  background: var(--mt-bg) !important;
  border: 2px solid var(--mt-s) !important;
  border-radius: 22px !important;
  padding: 0 !important;
  overflow: hidden;
  display: flex !important;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
  position: relative;
}
.mt-type-card-wide::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background:
    linear-gradient(
      90deg,
      var(--mt-p),
      var(--mt-s),
      var(--mt-g));
}
.mt-type-card-wide-left {
  display: flex !important;
  align-items: flex-start;
  gap: 22px;
  flex: 1;
  padding: 32px 32px 32px 32px !important;
  min-width: 0;
}
.mt-type-card-wide-text {
  flex: 1;
  min-width: 0;
}
.mt-type-card-wide .mt-type-icon {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  background:
    linear-gradient(
      135deg,
      var(--mt-p),
      var(--mt-s));
  display: flex !important;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
  box-shadow: 0 8px 22px rgba(11, 79, 108, .22);
  margin: 0 !important;
}
.mt-type-name {
  font-size: 26px !important;
  font-weight: 900 !important;
  color: var(--mt-d) !important;
  margin-bottom: 4px !important;
  line-height: 1.2 !important;
}
.mt-type-when {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: var(--mt-mu) !important;
  text-transform: uppercase;
  letter-spacing: .07em;
  margin-bottom: 10px;
  display: block;
}
.mt-type-desc {
  font-size: 14px !important;
  color: var(--mt-tl) !important;
  line-height: 1.65 !important;
  max-width: 540px;
}
.mt-type-highlights {
  display: flex !important;
  flex-direction: column;
  gap: 10px;
  padding: 32px 32px 32px 24px !important;
  border-left: 1.5px solid var(--mt-bo);
  flex-shrink: 0;
  min-width: 260px;
  align-items: stretch;
}
.mt-type-hl {
  display: flex !important;
  align-items: center;
  gap: 10px;
  font-size: 13px !important;
  font-weight: 700 !important;
  color: var(--mt-tx) !important;
  padding: 8px 12px !important;
  background: var(--mt-surf) !important;
  border-radius: 10px !important;
  border: 1.5px solid var(--mt-bo) !important;
}
.mt-type-hl svg {
  color: var(--mt-f2f);
  flex-shrink: 0;
}
.mt-type-scroll-btn {
  display: flex !important;
  align-items: center;
  justify-content: center;
  background: var(--mt-g) !important;
  color: var(--mt-d) !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 13px 20px !important;
  font-size: 15px !important;
  font-weight: 900 !important;
  cursor: pointer;
  font-family: inherit;
  margin-top: 4px;
  transition: transform .2s, box-shadow .2s;
  box-shadow: 0 4px 14px rgba(245, 166, 35, .25);
}
.mt-type-scroll-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 22px rgba(245, 166, 35, .35) !important;
}
.mt-centres {
  padding: 64px 0 !important;
  background: var(--mt-bg) !important;
  width: 100% !important;
}
.mt-centre-grid {
  display: grid !important;
  grid-template-columns: repeat(4, 1fr) !important;
  gap: 12px !important;
  width: 100% !important;
}
.mt-centre-card {
  background: var(--mt-surf) !important;
  border: 1.5px solid var(--mt-bo) !important;
  border-left: 4px solid var(--mt-p) !important;
  border-radius: 14px !important;
  padding: 16px 14px 14px !important;
  cursor: pointer;
  text-decoration: none !important;
  display: flex !important;
  flex-direction: column;
  gap: 4px;
  transition:
    border-color .2s,
    transform .2s,
    box-shadow .2s;
}
.mt-centre-card:hover {
  border-color: var(--mt-s) !important;
  border-left-color: var(--mt-s) !important;
  transform: translateX(4px);
  box-shadow: 0 4px 20px rgba(1, 186, 239, .1) !important;
}
.mt-centre-region {
  font-size: 10px !important;
  font-weight: 800 !important;
  text-transform: uppercase;
  letter-spacing: .1em;
  color: var(--mt-s) !important;
}
.mt-centre-name {
  font-size: 17px !important;
  font-weight: 900 !important;
  color: var(--mt-d) !important;
  line-height: 1.2 !important;
}
.mt-centre-boards {
  font-size: 11px !important;
  color: var(--mt-tl) !important;
  line-height: 1.5 !important;
  flex: 1;
}
.mt-centre-arrow {
  font-size: 14px !important;
  color: var(--mt-s) !important;
  font-weight: 800 !important;
  margin-top: 6px;
}
.mt-filterbar {
  position: sticky !important;
  top: 0;
  z-index: 200;
  background: #0a2535 !important;
  border-bottom: 3px solid var(--mt-s);
  box-shadow: 0 4px 24px rgba(0, 0, 0, .35);
  width: 100% !important;
}
.mt-filterbar-main {
  padding: 16px 0 !important;
}
.mt-filters-row {
  display: flex !important;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}
.mt-fg {
  display: flex !important;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 0;
}
.mt-fg--search {
  flex: 2;
  min-width: 200px;
}
.mt-fg--mode {
  flex: 1.6;
  min-width: 210px;
}
.mt-flabel {
  display: flex !important;
  align-items: center;
  gap: 5px;
  font-size: 10px !important;
  font-weight: 800 !important;
  text-transform: uppercase;
  letter-spacing: .12em;
  color: rgba(255, 255, 255, .75) !important;
}
.mt-fselect,
.mt-finput {
  background: #ffffff !important;
  border: 2px solid var(--mt-bo) !important;
  border-radius: 10px !important;
  padding: 10px 14px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: var(--mt-d) !important;
  font-family: inherit;
  outline: none !important;
  width: 100%;
  transition: border-color .2s, box-shadow .2s;
  appearance: none;
  -webkit-appearance: none;
}
.mt-fselect:focus,
.mt-finput:focus {
  border-color: var(--mt-s) !important;
  box-shadow: 0 0 0 3px rgba(1, 186, 239, .2) !important;
}
.mt-fselect option {
  background: #fff;
  color: var(--mt-d);
}
.mt-finput::placeholder {
  color: #7a9cae !important;
  font-weight: 500;
}
.mt-mode-toggle {
  display: flex !important;
  border-radius: 10px !important;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, .2) !important;
  width: 100%;
  height: 42px;
  background: rgba(255, 255, 255, .08) !important;
}
.mt-mode-toggle-btn {
  flex: 1;
  display: flex !important;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 10px !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  border: none !important;
  background: transparent !important;
  color: rgba(255, 255, 255, .65) !important;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  transition: background .15s, color .15s;
}
.mt-mode-toggle-btn + .mt-mode-toggle-btn {
  border-left: 1px solid rgba(255, 255, 255, .15) !important;
}
.mt-mode-toggle-btn--f2f.mt-mode-toggle-btn--active {
  background: #0B8A4E !important;
  color: #ffffff !important;
  font-weight: 800 !important;
}
.mt-mode-toggle-btn--online.mt-mode-toggle-btn--active {
  background: #7C3AED !important;
  color: #ffffff !important;
  font-weight: 800 !important;
}
.mt-mode-toggle-btn--all.mt-mode-toggle-btn--active {
  background: var(--mt-s) !important;
  color: #06253A !important;
  font-weight: 800 !important;
}
.mt-mode-toggle-btn--f2f:not(.mt-mode-toggle-btn--active):hover {
  background: rgba(11, 138, 78, .3) !important;
  color: #5FFFA8 !important;
}
.mt-mode-toggle-btn--online:not(.mt-mode-toggle-btn--active):hover {
  background: rgba(124, 58, 237, .3) !important;
  color: #d0b4ff !important;
}
.mt-mode-toggle-btn--all:not(.mt-mode-toggle-btn--active):hover {
  background: rgba(1, 186, 239, .2) !important;
  color: var(--mt-s) !important;
}
.mt-freset {
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
  background: rgba(220, 50, 50, .2) !important;
  border: 2px solid rgba(220, 50, 50, .45) !important;
  border-radius: 10px !important;
  padding: 10px 16px !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  color: #ff9090 !important;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  align-self: flex-end;
  transition: background .2s, border-color .2s;
}
.mt-freset:hover {
  background: rgba(220, 50, 50, .35) !important;
  border-color: #ff6060 !important;
  color: #ffbaba !important;
}
.mt-foffers {
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
  background: var(--mt-g) !important;
  border: none !important;
  border-radius: 10px !important;
  padding: 10px 16px !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  color: var(--mt-d) !important;
  cursor: pointer;
  text-decoration: none !important;
  white-space: nowrap;
  align-self: flex-end;
  transition: transform .15s, box-shadow .15s;
}
.mt-foffers:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(245, 166, 35, .35) !important;
}
.mt-filterbar-pills {
  border-top: 1px solid rgba(255, 255, 255, .1);
  padding: 8px 0 10px !important;
}
.mt-pills-row {
  display: flex !important;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.mt-pills-label {
  font-size: 11px !important;
  font-weight: 700 !important;
  color: rgba(255, 255, 255, .4) !important;
  white-space: nowrap;
}
.mt-pill {
  display: inline-flex !important;
  align-items: center;
  gap: 5px;
  background: rgba(1, 186, 239, .18) !important;
  border: 1px solid rgba(1, 186, 239, .35) !important;
  border-radius: 100px !important;
  padding: 4px 10px !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  color: var(--mt-s) !important;
}
.mt-pill-x {
  background: none !important;
  border: none !important;
  cursor: pointer;
  color: var(--mt-s) !important;
  font-size: 12px;
  padding: 0;
  opacity: .7;
  line-height: 1;
  font-family: inherit;
  transition: opacity .15s;
}
.mt-pill-x:hover {
  opacity: 1;
}
.mt-count {
  margin-left: auto;
  font-size: 12px !important;
  font-weight: 700 !important;
  color: rgba(255, 255, 255, .45) !important;
}
.mt-cal-heading {
  background: var(--mt-bg);
  padding: 48px 0 0 !important;
  width: 100% !important;
}
.mt-sessions {
  padding: 24px 0 72px !important;
  background: var(--mt-bg) !important;
  width: 100% !important;
}
.mt-sortbar {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 8px;
}
.mt-sortbar-count {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: var(--mt-mu) !important;
}
.mt-sortbar-count strong {
  color: var(--mt-p) !important;
}
.mt-sortbar-right {
  display: flex !important;
  align-items: center;
  gap: 6px;
  font-size: 12px !important;
  font-weight: 700 !important;
  color: var(--mt-mu) !important;
}
.mt-scard {
  background: var(--mt-surf) !important;
  border: 1.5px solid var(--mt-bo) !important;
  border-radius: 16px !important;
  margin-bottom: 10px;
  display: grid !important;
  grid-template-columns: 88px 1fr auto auto !important;
  align-items: stretch;
  overflow: hidden;
  transition:
    border-color .2s,
    box-shadow .2s,
    transform .15s;
}
.mt-scard:hover {
  border-color: var(--mt-s) !important;
  box-shadow: 0 4px 24px rgba(1, 186, 239, .1) !important;
  transform: translateY(-2px);
}
.mt-scard--today {
  border-color: var(--mt-g) !important;
  box-shadow: 0 0 0 3px rgba(245, 166, 35, .1) !important;
}
.mt-scard-date {
  background: var(--mt-p);
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 14px 8px !important;
  color: #fff;
  text-align: center;
  flex-shrink: 0;
}
.mt-scard-date--range {
  background: var(--mt-g) !important;
}
.mt-scard-date--range .mt-scard-day,
.mt-scard-date--range .mt-scard-mon,
.mt-scard-date--range .mt-scard-yr {
  color: var(--mt-d) !important;
}
.mt-scard-from {
  font-size: 9px !important;
  font-weight: 700 !important;
  color: rgba(255, 255, 255, .55) !important;
  text-transform: uppercase;
  letter-spacing: .06em;
  display: block;
  margin-bottom: 1px;
}
.mt-scard-day {
  font-size: 28px !important;
  font-weight: 900 !important;
  color: #fff !important;
  line-height: 1;
  display: block;
}
.mt-scard-mon {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: rgba(255, 255, 255, .7) !important;
  text-transform: uppercase;
  letter-spacing: .04em;
  display: block;
  line-height: 1.2;
}
.mt-scard-yr {
  font-size: 11px !important;
  font-weight: 600 !important;
  color: rgba(255, 255, 255, .5) !important;
  display: block;
}
.mt-scard-date--tbd {
  background: var(--mt-mu) !important;
  justify-content: center !important;
  gap: 6px;
}
.mt-scard-tbd {
  font-size: 12px !important;
  font-weight: 900 !important;
  color: rgba(255, 255, 255, .7) !important;
  letter-spacing: .08em;
  text-transform: uppercase;
  display: block;
}
.mt-scard-info {
  padding: 14px 18px !important;
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  min-width: 0;
}
.mt-scard-top {
  display: flex !important;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.mt-scard-cat {
  font-size: 16px !important;
  font-weight: 800 !important;
  color: var(--mt-p) !important;
  text-decoration: none !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color .2s;
}
.mt-scard-cat:hover {
  color: var(--mt-s) !important;
}
.mt-scard-mode {
  display: inline-flex !important;
  align-items: center;
  gap: 5px;
  border-radius: 100px;
  padding: 3px 10px !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  white-space: nowrap;
  flex-shrink: 0;
}
.mt-scard-mode--online {
  background: #f3edfc !important;
  color: var(--mt-onl) !important;
}
.mt-scard-mode--f2f {
  background: #e4f4ef !important;
  color: var(--mt-f2f) !important;
}
.mt-mode-dot-sm {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  flex-shrink: 0;
}
.mt-scard-type {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: var(--mt-tx) !important;
  text-decoration: none !important;
}
.mt-scard-name {
  font-size: 12px !important;
  color: var(--mt-mu) !important;
  font-weight: 600 !important;
  text-decoration: none !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mt-scard-loc {
  display: flex !important;
  align-items: center;
  gap: 5px;
  font-size: 12px !important;
  font-weight: 700 !important;
  color: var(--mt-p) !important;
  margin-top: 4px;
}
.mt-scard-price {
  padding: 14px 16px !important;
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-left: 1px solid var(--mt-bo);
  min-width: 88px;
}
.mt-price-free {
  font-size: 15px !important;
  font-weight: 900 !important;
  color: var(--mt-f2f) !important;
}
.mt-price-val {
  font-size: 20px !important;
  font-weight: 900 !important;
  color: var(--mt-d) !important;
  line-height: 1;
}
.mt-price-lbl {
  font-size: 10px !important;
  color: var(--mt-mu) !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: .05em;
  margin-top: 2px;
}
.mt-scard-book {
  padding: 14px 18px !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  border-left: 1px solid var(--mt-bo);
  background: rgba(245, 166, 35, .06);
}
.mt-book-btn {
  display: flex !important;
  align-items: center;
  gap: 8px;
  background: var(--mt-g) !important;
  color: var(--mt-d) !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 22px !important;
  font-size: 15px !important;
  font-weight: 900 !important;
  cursor: pointer;
  text-decoration: none !important;
  transition:
    transform .2s,
    box-shadow .2s,
    background .2s;
  white-space: nowrap;
  box-shadow: 0 3px 0 rgba(180, 110, 0, .25);
}
.mt-book-btn:hover {
  background: var(--mt-p) !important;
  color: #fff !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(245, 166, 35, .3) !important;
}
.mt-loadmore {
  text-align: center;
  padding: 28px 0;
}
.mt-loadmore-btn {
  background: var(--mt-surf) !important;
  border: 1.5px solid var(--mt-bo) !important;
  border-radius: 100px !important;
  padding: 12px 32px !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  color: var(--mt-p) !important;
  cursor: pointer;
  font-family: inherit;
  transition:
    background .2s,
    border-color .2s,
    color .2s;
}
.mt-loadmore-btn:hover {
  background: var(--mt-p) !important;
  border-color: var(--mt-p) !important;
  color: #fff !important;
}
.mt-empty {
  text-align: center;
  padding: 64px 20px;
  background: var(--mt-surf);
  border: 1.5px solid var(--mt-bo);
  border-radius: 16px;
}
.mt-empty-ico {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  background: var(--mt-li);
  display: flex !important;
  align-items: center;
  justify-content: center;
  color: var(--mt-mu);
  margin: 0 auto 16px;
}
.mt-empty-title {
  font-size: 18px !important;
  font-weight: 800 !important;
  color: var(--mt-d) !important;
  margin-bottom: 8px !important;
}
.mt-empty-sub {
  font-size: 14px !important;
  color: var(--mt-mu) !important;
  margin-bottom: 20px !important;
}
.mt-empty-reset {
  background: none !important;
  border: 1.5px solid var(--mt-bo) !important;
  border-radius: 100px !important;
  padding: 10px 24px !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  color: var(--mt-p) !important;
  cursor: pointer;
  font-family: inherit;
  transition: background .2s, border-color .2s;
}
.mt-empty-reset:hover {
  background: var(--mt-li) !important;
  border-color: var(--mt-s) !important;
}
.mt-pathway {
  background: var(--mt-surf) !important;
  border-top: 1px solid var(--mt-bo);
  border-bottom: 1px solid var(--mt-bo);
  padding: 28px 0 !important;
  width: 100% !important;
}
.mt-pathway-inner {
  display: flex !important;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0;
  width: 100% !important;
}
.mt-pstep {
  display: flex !important;
  align-items: center;
  gap: 12px;
  padding: 10px 22px !important;
}
.mt-pstep-ico {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: var(--mt-li);
  display: flex !important;
  align-items: center;
  justify-content: center;
  color: var(--mt-p);
  flex-shrink: 0;
  transition: background .2s, color .2s;
}
.mt-pstep:hover .mt-pstep-ico {
  background: var(--mt-s);
  color: #fff;
}
.mt-pstep-ico--gold {
  background: rgba(245, 166, 35, .15) !important;
  color: var(--mt-g) !important;
}
.mt-pstep--goal:hover .mt-pstep-ico {
  background: var(--mt-g) !important;
  color: var(--mt-d) !important;
}
.mt-pstep-text strong {
  display: block;
  font-size: 13px !important;
  font-weight: 800 !important;
  color: var(--mt-d) !important;
}
.mt-pstep-text span {
  font-size: 11px !important;
  color: var(--mt-mu) !important;
  font-weight: 600 !important;
}
.mt-parrow {
  font-size: 18px;
  color: var(--mt-bo);
  font-weight: 700;
  flex-shrink: 0;
  padding: 0 4px;
}
.mt-benefits {
  padding: 72px 0 !important;
  background:
    linear-gradient(
      135deg,
      #f8fafc 0%,
      var(--mt-li) 100%) !important;
  width: 100% !important;
}
.mt-benefits-inner {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 64px !important;
  align-items: center !important;
  width: 100% !important;
}
.mt-benefits-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 12px !important;
  margin-top: 24px !important;
}
.mt-benefit {
  display: flex !important;
  align-items: flex-start;
  gap: 10px;
  background: var(--mt-surf) !important;
  border-radius: 12px !important;
  padding: 14px !important;
  box-shadow: 0 2px 10px rgba(11, 79, 108, .05);
  transition: transform .2s;
}
.mt-benefit:hover {
  transform: translateY(-2px);
}
.mt-benefit-ico {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background:
    linear-gradient(
      135deg,
      var(--mt-p),
      var(--mt-s));
  display: flex !important;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
}
.mt-benefit span {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: var(--mt-tx) !important;
  line-height: 1.5 !important;
}
.mt-benefits-img {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 56px rgba(11, 79, 108, .15);
}
.mt-benefits-img img {
  width: 100% !important;
  height: 420px !important;
  object-fit: cover !important;
  display: block !important;
}
.mt-included {
  padding: 72px 0 !important;
  background: var(--mt-surf) !important;
  width: 100% !important;
}
.mt-included-inner {
  display: grid !important;
  grid-template-columns: 1fr 360px !important;
  gap: 40px !important;
  align-items: start;
  width: 100% !important;
}
.mt-features {
  display: flex !important;
  flex-direction: column;
  gap: 14px;
}
.mt-feature {
  display: flex !important;
  align-items: flex-start;
  gap: 16px;
  padding: 18px 20px !important;
  background: var(--mt-bg) !important;
  border: 1.5px solid var(--mt-bo) !important;
  border-radius: 14px !important;
  transition: border-color .2s, transform .2s;
}
.mt-feature:hover {
  border-color: var(--mt-s) !important;
  transform: translateX(5px);
}
.mt-feature-ico {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background:
    linear-gradient(
      135deg,
      var(--mt-p),
      var(--mt-s));
  display: flex !important;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
  box-shadow: 0 5px 15px rgba(11, 79, 108, .18);
}
.mt-feature-ico svg {
  width: 20px;
  height: 20px;
  stroke: #fff;
}
.mt-feature-title {
  font-size: 15px !important;
  font-weight: 800 !important;
  color: var(--mt-d) !important;
  margin-bottom: 4px !important;
}
.mt-feature-text {
  font-size: 13px !important;
  color: var(--mt-tl) !important;
  line-height: 1.6 !important;
}
.mt-vis-card {
  background:
    linear-gradient(
      135deg,
      var(--mt-p),
      #0a6070) !important;
  border-radius: 20px !important;
  padding: 36px 28px !important;
  text-align: center;
  box-shadow: 0 20px 56px rgba(11, 79, 108, .25);
  position: sticky;
  top: 100px;
}
.mt-vis-ico {
  width: 72px;
  height: 72px;
  background: rgba(255, 255, 255, .15);
  border-radius: 18px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin: 0 auto 20px;
}
.mt-vis-title {
  font-size: 22px !important;
  font-weight: 900 !important;
  color: #fff !important;
  margin-bottom: 8px !important;
}
.mt-vis-sub {
  font-size: 13px !important;
  color: rgba(255, 255, 255, .7) !important;
  line-height: 1.6 !important;
  margin-bottom: 24px !important;
}
.mt-vis-stats {
  display: flex !important;
  justify-content: center;
  gap: 24px;
  margin-bottom: 28px;
}
.mt-vstat {
  text-align: center;
}
.mt-vstat-n {
  display: block;
  font-size: 26px !important;
  font-weight: 900 !important;
  color: #fff !important;
  line-height: 1;
  margin-bottom: 3px !important;
}
.mt-vstat-l {
  font-size: 10px !important;
  color: rgba(255, 255, 255, .55) !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: .05em;
}
.mt-vis-cta {
  width: 100% !important;
  background: var(--mt-g) !important;
  color: var(--mt-d) !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 14px 20px !important;
  font-size: 15px !important;
  font-weight: 800 !important;
  cursor: pointer;
  font-family: inherit;
  transition: transform .2s;
}
.mt-vis-cta:hover {
  transform: translateY(-2px);
}
.mt-testi {
  padding: 72px 0 !important;
  background:
    linear-gradient(
      135deg,
      #06253A 0%,
      var(--mt-p) 60%,
      #0a6070 100%) !important;
  width: 100% !important;
  position: relative;
  overflow: hidden;
}
.mt-testi::before {
  content: "";
  position: absolute;
  width: 500px;
  height: 500px;
  border-radius: 50%;
  background:
    radial-gradient(
      circle,
      rgba(1, 186, 239, .06) 0%,
      transparent 70%);
  top: -200px;
  right: -120px;
  pointer-events: none;
}
.mt-testi-grid {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr) !important;
  gap: 18px !important;
  width: 100% !important;
  position: relative;
  z-index: 1;
}
.mt-tcard {
  background: rgba(255, 255, 255, .07) !important;
  border: 1.5px solid rgba(255, 255, 255, .12) !important;
  border-radius: 18px !important;
  padding: 24px !important;
  position: relative;
  transition: background .2s;
}
.mt-tcard:hover {
  background: rgba(255, 255, 255, .11) !important;
}
.mt-tcard-quote {
  position: absolute;
  top: 10px;
  right: 18px;
  font-size: 56px;
  font-weight: 900;
  color: rgba(255, 255, 255, .08);
  line-height: 1;
}
.mt-tcard-text {
  font-size: 13px !important;
  color: rgba(255, 255, 255, .75) !important;
  line-height: 1.75 !important;
  font-style: italic;
  margin-bottom: 16px !important;
}
.mt-tcard-name {
  font-size: 14px !important;
  font-weight: 800 !important;
  color: var(--mt-g) !important;
  display: flex;
  align-items: center;
  gap: 8px;
}
.mt-tcard-name::before {
  content: "";
  width: 20px;
  height: 2px;
  background: var(--mt-g);
  border-radius: 2px;
  display: block;
  flex-shrink: 0;
}
.mt-faq {
  padding: 72px 0 !important;
  background: var(--mt-bg) !important;
  width: 100% !important;
}
.mt-faq-list {
  max-width: 760px;
  margin: 0 auto !important;
}
.mt-faq-item {
  border: 1.5px solid var(--mt-bo) !important;
  border-radius: 14px !important;
  margin-bottom: 10px;
  overflow: hidden;
  transition: border-color .2s;
}
.mt-faq-item:hover {
  border-color: var(--mt-s) !important;
}
.mt-faq-q {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  padding: 17px 22px !important;
  cursor: pointer;
  font-size: 15px !important;
  font-weight: 700 !important;
  color: var(--mt-d) !important;
  gap: 12px;
  background: var(--mt-surf);
  border: none !important;
  width: 100%;
  text-align: left;
  font-family: inherit;
}
.mt-faq-q:hover {
  background: var(--mt-li);
}
.mt-faq-chev {
  flex-shrink: 0;
  transition: transform .3s;
  color: var(--mt-p);
}
.mt-faq-item--open .mt-faq-chev {
  transform: rotate(180deg);
  color: var(--mt-s);
}
.mt-faq-a {
  max-height: 0;
  overflow: hidden;
  background: var(--mt-bg);
  border-top: 1px solid var(--mt-bo);
  font-size: 14px !important;
  color: var(--mt-tl) !important;
  line-height: 1.7 !important;
  transition: max-height .35s ease, padding .35s;
  padding: 0 22px !important;
}
.mt-faq-item--open .mt-faq-a {
  max-height: 300px;
  padding: 16px 22px !important;
}
.mt-contact {
  background:
    linear-gradient(
      90deg,
      var(--mt-d) 0%,
      var(--mt-p) 100%) !important;
  padding: 36px 0 !important;
  width: 100% !important;
}
.mt-contact-inner {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}
.mt-contact-title {
  font-size: 17px !important;
  font-weight: 800 !important;
  color: #fff !important;
}
.mt-contact-links {
  display: flex !important;
  gap: 14px;
  flex-wrap: wrap;
}
.mt-contact-link {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, .1);
  border: 1px solid rgba(255, 255, 255, .18);
  border-radius: 100px;
  padding: 9px 20px;
  font-size: 14px !important;
  font-weight: 700 !important;
  color: rgba(255, 255, 255, .9) !important;
  text-decoration: none !important;
  transition: background .2s;
}
.mt-contact-link:hover {
  background: rgba(255, 255, 255, .2);
  color: var(--mt-g) !important;
}
.mt-page section,
.mt-page .mt-offers,
.mt-page .mt-pathway,
.mt-page .mt-filterbar,
.mt-page .mt-sessions,
.mt-page .mt-contact {
  width: 100% !important;
  float: none !important;
}
.mt-page .mt-container {
  max-width: 1240px !important;
  width: 100% !important;
  margin-left: auto !important;
  margin-right: auto !important;
  padding-left: 48px !important;
  padding-right: 48px !important;
  float: none !important;
  box-sizing: border-box !important;
}
.mt-page .mt-filterbar .mt-container,
.mt-page .mt-filterbar-pills .mt-container {
  padding-left: 40px !important;
  padding-right: 40px !important;
}
@media (max-width: 1100px) {
  .mt-centre-grid {
    grid-template-columns: repeat(3, 1fr) !important;
  }
  .mt-testi-grid {
    grid-template-columns: 1fr 1fr !important;
  }
  .mt-included-inner {
    grid-template-columns: 1fr !important;
  }
  .mt-vis-card {
    position: static;
  }
  .mt-type-card-wide {
    flex-direction: column !important;
  }
  .mt-type-highlights {
    border-left: none !important;
    border-top: 1.5px solid var(--mt-bo) !important;
    flex-direction: row !important;
    flex-wrap: wrap !important;
    padding: 20px 28px 24px !important;
    width: 100% !important;
  }
  .mt-type-hl {
    flex: 1;
    min-width: 180px;
  }
  .mt-type-scroll-btn {
    width: 100%;
  }
}
@media (max-width: 900px) {
  .mt-hero-inner {
    grid-template-columns: 1fr !important;
    gap: 32px !important;
  }
  .mt-benefits-inner {
    grid-template-columns: 1fr !important;
    gap: 36px !important;
  }
  .mt-centre-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
  .mt-scard {
    grid-template-columns: 68px 1fr auto !important;
  }
  .mt-scard-price {
    display: none !important;
  }
  .mt-container {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  .mt-page .mt-filterbar .mt-container {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .mt-page .mt-filterbar-pills .mt-container {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .mt-fg--mode {
    min-width: 100% !important;
    flex: 0 0 100% !important;
  }
  .mt-mode-toggle-btn {
    font-size: 13px !important;
    padding: 0 12px !important;
  }
}
@media (max-width: 480px) {
  .mt-container {
    padding-left: 14px !important;
    padding-right: 14px !important;
  }
  .mt-page .mt-filterbar .mt-container {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
  .mt-page .mt-filterbar-pills .mt-container {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
  .mt-hero {
    padding: 56px 0 44px !important;
  }
  .mt-hero-title {
    font-size: 28px !important;
    letter-spacing: -.5px;
  }
  .mt-hero-sub {
    font-size: 13px !important;
  }
  .mt-hero-actions {
    flex-direction: column !important;
    gap: 10px !important;
  }
  .mt-btn-primary,
  .mt-btn-ghost {
    width: 100% !important;
    justify-content: center !important;
  }
  .mt-hero-stats {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 0 !important;
    padding: 0 !important;
    border-radius: 14px !important;
    overflow: hidden;
  }
  .mt-hstat {
    padding: 14px 10px !important;
  }
  .mt-hstat strong {
    font-size: 15px !important;
  }
  .mt-hstat span {
    font-size: 9px !important;
  }
  .mt-hstat-div {
    display: none !important;
  }
  .mt-hero-guide {
    padding: 20px 16px !important;
  }
  .mt-gstep-label {
    font-size: 13px !important;
  }
  .mt-offers-inner {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 8px !important;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }
  .mt-offers-btn {
    width: 100% !important;
    text-align: center !important;
    justify-content: center !important;
  }
  .mt-types {
    padding: 40px 0 !important;
  }
  .mt-type-card-wide {
    flex-direction: column !important;
  }
  .mt-type-card-wide-left {
    flex-direction: column !important;
    padding: 20px 16px 16px !important;
    gap: 14px !important;
  }
  .mt-type-card-wide .mt-type-icon {
    width: 48px !important;
    height: 48px !important;
  }
  .mt-type-name {
    font-size: 20px !important;
  }
  .mt-type-desc {
    font-size: 13px !important;
  }
  .mt-type-highlights {
    border-left: none !important;
    border-top: 1.5px solid var(--mt-bo) !important;
    flex-direction: column !important;
    padding: 16px !important;
    gap: 8px !important;
    width: 100% !important;
  }
  .mt-type-hl {
    font-size: 12px !important;
    padding: 7px 10px !important;
  }
  .mt-type-scroll-btn {
    font-size: 14px !important;
    padding: 12px 16px !important;
  }
  .mt-centres {
    padding: 44px 0 !important;
  }
  .mt-centre-grid {
    grid-template-columns: 1fr 1fr !important;
    gap: 8px !important;
  }
  .mt-centre-card {
    padding: 12px 10px 10px !important;
  }
  .mt-centre-name {
    font-size: 14px !important;
  }
  .mt-centre-region {
    font-size: 9px !important;
  }
  .mt-centre-boards {
    font-size: 10px !important;
    line-height: 1.4 !important;
  }
  .mt-centre-arrow {
    display: none !important;
  }
  .mt-cal-heading {
    padding: 32px 0 0 !important;
  }
  .mt-filters-row {
    flex-direction: column !important;
    gap: 10px !important;
  }
  .mt-fg,
  .mt-fg--mode {
    min-width: 100% !important;
    flex: 0 0 100% !important;
  }
  .mt-fselect,
  .mt-finput {
    font-size: 15px !important;
    padding: 12px 14px !important;
    border-radius: 10px !important;
  }
  .mt-freset,
  .mt-foffers {
    width: 100% !important;
    justify-content: center !important;
    border-radius: 10px !important;
    padding: 12px 16px !important;
  }
  .mt-mode-toggle {
    height: 46px;
  }
  .mt-mode-toggle-btn {
    font-size: 13px !important;
  }
  .mt-scard {
    display: flex !important;
    flex-direction: column !important;
    border-radius: 14px !important;
    overflow: hidden;
    margin-bottom: 10px;
  }
  .mt-scard-date {
    flex-direction: row !important;
    align-items: center !important;
    justify-content: flex-start !important;
    padding: 10px 14px !important;
    gap: 8px;
    min-height: auto !important;
  }
  .mt-scard-day {
    font-size: 20px !important;
    line-height: 1 !important;
  }
  .mt-scard-mon {
    font-size: 12px !important;
  }
  .mt-scard-yr {
    font-size: 11px !important;
  }
  .mt-scard-from {
    display: none !important;
  }
  .mt-scard-tbd {
    font-size: 11px !important;
  }
  .mt-scard-info {
    padding: 12px 14px 8px !important;
    gap: 5px !important;
  }
  .mt-scard-cat {
    font-size: 14px !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: unset !important;
    line-height: 1.3 !important;
  }
  .mt-scard-mode {
    font-size: 10px !important;
    padding: 2px 8px !important;
  }
  .mt-scard-type {
    font-size: 12px !important;
  }
  .mt-scard-name {
    font-size: 11px !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: unset !important;
    line-height: 1.4 !important;
  }
  .mt-scard-loc {
    font-size: 11px !important;
    margin-top: 3px;
  }
  .mt-scard-price {
    display: none !important;
  }
  .mt-scard-book {
    border-left: none !important;
    border-top: 1px solid var(--mt-bo) !important;
    padding: 10px 14px !important;
    background: rgba(245, 166, 35, .06);
    justify-content: stretch !important;
  }
  .mt-book-btn {
    width: 100% !important;
    justify-content: center !important;
    padding: 12px 16px !important;
    font-size: 14px !important;
    border-radius: 10px !important;
    box-shadow: none !important;
  }
  .mt-sortbar {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 4px !important;
  }
  .mt-sortbar-right {
    font-size: 11px !important;
  }
  .mt-pathway {
    padding: 20px 0 !important;
  }
  .mt-pathway-inner {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 8px !important;
  }
  .mt-parrow {
    display: none !important;
  }
  .mt-pstep {
    padding: 6px 14px !important;
  }
  .mt-pstep-ico {
    width: 36px !important;
    height: 36px !important;
    border-radius: 10px !important;
  }
  .mt-benefits {
    padding: 48px 0 !important;
  }
  .mt-benefits-grid {
    grid-template-columns: 1fr !important;
    gap: 8px !important;
  }
  .mt-benefits-img img {
    height: 260px !important;
  }
  .mt-included {
    padding: 48px 0 !important;
  }
  .mt-feature {
    padding: 14px !important;
    gap: 12px !important;
  }
  .mt-feature-ico {
    width: 36px !important;
    height: 36px !important;
    border-radius: 9px !important;
  }
  .mt-feature-title {
    font-size: 14px !important;
  }
  .mt-feature-text {
    font-size: 12px !important;
  }
  .mt-vis-card {
    padding: 24px 18px !important;
  }
  .mt-vis-title {
    font-size: 18px !important;
  }
  .mt-vis-stats {
    gap: 16px !important;
  }
  .mt-vstat-n {
    font-size: 20px !important;
  }
  .mt-testi {
    padding: 48px 0 !important;
  }
  .mt-testi-grid {
    grid-template-columns: 1fr !important;
    gap: 12px !important;
  }
  .mt-tcard {
    padding: 18px !important;
  }
  .mt-tcard-text {
    font-size: 12px !important;
  }
  .mt-faq {
    padding: 48px 0 !important;
  }
  .mt-faq-q {
    padding: 14px 16px !important;
    font-size: 14px !important;
  }
  .mt-faq-a {
    padding: 0 16px !important;
  }
  .mt-faq-item--open .mt-faq-a {
    padding: 13px 16px !important;
    font-size: 13px !important;
  }
  .mt-contact {
    padding: 28px 0 !important;
  }
  .mt-contact-inner {
    flex-direction: column !important;
    gap: 12px !important;
  }
  .mt-contact-links {
    flex-direction: column !important;
    gap: 8px !important;
    width: 100% !important;
  }
  .mt-contact-link {
    width: 100% !important;
    justify-content: center !important;
  }
  .mt-section-title {
    font-size: 22px !important;
  }
  .mt-section-hd {
    margin-bottom: 28px !important;
  }
  .mt-section-sub {
    font-size: 13px !important;
  }
}
/*# sourceMappingURL=elev-plus-tests.component.css.map */
